var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.025 19.025a.938.938 0 011.328 0l4.961 4.964 4.961-4.964a.94.94 0 011.531.305.938.938 0 01-.203 1.023l-4.963 4.961 4.963 4.961a.94.94 0 01-1.328 1.328l-4.96-4.963-4.962 4.963a.938.938 0 11-1.328-1.328l4.964-4.96-4.964-4.962a.938.938 0 010-1.328z",
    fill: "#000"
  })));
}

export default SvgLedCloseIcon;